var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarYellowRatings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.381 15.996l6.415 3.87-1.696-7.3 5.662-4.91-7.465-.64L10.38.133 7.465 7.016 0 7.656l5.663 4.91-1.698 7.3 6.416-3.87z",
    fill: "#FFB700"
  })));
}

export default SvgStarYellowRatings;